import React from "react";
import { Pagination, PaginationProps, Select, Row, Col } from "antd";

const { Option } = Select;
const PAGE_SIZES = [10, 12, 20, 25, 50, 100];

interface IProps extends PaginationProps {
	pageSizes?: number[];
}
const CustomPagination: React.FC<IProps> = (props) => {
	return (
		<Pagination
			{...props}
			showSizeChanger={false}
			responsive={true}
			showTotal={(total, range) => (
				<Row gutter={20}>
					<Col>Per page</Col>
					<Col>
						<Select
							className="page-size-custom-select"
							size="small"
							value={props.pageSize}
							onChange={(newPageSize) => {
								if (props.onChange) {
									let current = props.current ? props.current : 1;
									if (props.pageSize && newPageSize > props.pageSize) {
										current = Math.max(
											current - Math.ceil((newPageSize - props.pageSize) / props.pageSize),
											1
										);
									}
									props.onChange(current, newPageSize);
								}
							}}
						>
							{(props.pageSizes ? props.pageSizes : PAGE_SIZES).map((item) => (
								<Option
									value={item}
									key={item}
								>
									{item}
								</Option>
							))}
						</Select>
					</Col>
					<Col>{`${range[0]}-${range[1]} of ${total}`}</Col>
				</Row>
			)}
		/>
	);
};
export default CustomPagination;
